import React from "react";
import withStyles from "elevate-ui/withStyles";

const Dropdown = ({ address, handlePage, classes }) => {
  return (
    <div onClick={() => handlePage(address)} className={classes.root}>
      <div className={classes.label}>{address.label}</div>
    </div>
  );
};
export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: "20px 24px",

    "&:nth-child(even)": {
      backgroundColor: "#f7f7f7",
    },

    "&:hover": {
      backgroundColor: theme.colors.gray["200"],
      cursor: "pointer",
      transition: "ease .2s background-color",
    },
  },
  label: {
    textAlign: "left",
  },
}))(Dropdown);
